<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

export default {
  page: {
    title: "Payments Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      filterPayments: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        customer: "",
        user: "",
        page: 1,
        per_page: 50,
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Payments Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Payments Report",
          active: true,
        },
      ],

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsPaymentsDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      amountError: "",
      data: {
        paid: "",
        id: "",
        filterdata: {},
      },
      editdata: {
        amount: "",
      },
      deletedata: {
        id: "",
        amount: "",
        filterdata: {},
      },
    };
  },
  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("sales", [
      "filterStatus",
      "SaveSaleStatus",
      "PaymentsData",
      "PaymentsDataPagination",
      "PaymentsDataSummary",
      "PaymentsDataPaginated",
    ]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapGetters("users", ["Users"]),

    rows() {
      return this.IsPaymentsDataServerPaginated
        ? this.PaymentsDataPagination.total
        : this.PaymentsData
        ? this.PaymentsData.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsPaymentsDataServerPaginated) {
          return (
            (this.PaymentsDataPagination &&
              this.PaymentsDataPagination.per_page) ||
            this.filterPayments.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsPaymentsDataServerPaginated) {
          this.filterPayments.per_page = value;
          this.filterPayments.page = 1;
          this.FetchPayments(this.filterPayments);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.PaymentsDataPaginated && this.PaymentsDataPagination
          ? this.PaymentsDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.PaymentsDataPaginated) {
          this.filterPayments.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.PaymentsDataSummary || {
          totalAmount: 0,
        }
      );
    },

    activeFields() {
      return this.branchid == 0 ? this.fields1 : this.fields;
    },

    paymentsColumns() {
      const cols = [
        { key: "index", label: "S/N" },
        { key: "customer", label: "CUSTOMER" },
        {
          key: "amount",
          label: "AMOUNT",
          formatter: (v) => this.thousandSeperator(v),
        },
        { key: "date", label: "DATE" },
        { key: "mode", label: "PAYMENT MODE" },
        { key: "receipt", label: "RECEIPT NO" },
        { key: "recordedby", label: "RECEIVED BY" },
        { key: "recordedon", label: "RECORDED ON" },
      ];

      if (this.branchid == 0) {
        cols.push({ key: "branch", label: "BRANCH" });
      }

      cols.push({ key: "actions", label: "ACTIONS", tdClass: "text-nowrap" });

      return cols;
    },
  },
  methods: {
    ...mapActions({
      FetchPayments: "sales/fetchPaymentsData",
      FetchCustomers: "customers/fetchCustomers",
      FetchBranches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      EditPaid: "sales/EditPayment",
      DeletePaid: "sales/DeletePayment",
      FetchUsers: "users/fetchUsers",
    }),

    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SalesPaymentsData() {
      let payload = { ...this.filterPayments };
      payload.page = 1;
      payload.per_page = this.IsPaymentsDataServerPaginated
        ? this.perPage
        : this.serverPerPage;

      this.FetchPayments(payload);
    },

    handlePageChange(newPage) {
      if (this.IsPaymentsDataServerPaginated) {
        this.filterPayments.page = newPage;
        this.FetchPayments(this.filterPayments);
      }
    },

    Excel_export() {
      axios
        .post("export_payments", this.filterPayments, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "payments_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {});
    },

    editAmt(modalId) {
      this.modal_id = modalId;
      if (this.data.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      this.data.filterdata = this.filterPayments;
      this.EditPaid(this.data);
    },

    deletePayment(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.filterPayments;
      this.DeletePaid(this.deletedata);
    },

    addCommas() {
      this.data.paid = this.thousandSeperator(this.data.paid);
    },

    resetError() {
      this.amountError = "";
    },

    closeModal(modalId) {
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    showEditModal(data) {
      this.editdata.amount = this.thousandSeperator(data.amount);
      this.data.paid = this.thousandSeperator(data.amount);
      this.data.id = data.id;
    },

    showDeleteModal(data) {
      this.deletedata.id = data.id;
      this.deletedata.amount = this.thousandSeperator(data.amount);
    },

    resetDelete() {
      this.deletedata.id = "";
      this.deletedata.amount = "";
    },
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.FetchPayments(this.filterPayments);
    this.FetchCustomers();
    this.FetchBranches();
    this.FetchGeneralSettings();
    this.FetchUsers();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">
        {{ business }}
      </h4>
      <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
        <em
          v-if="
            GeneralSettings.show_branchname == 1 &&
            GeneralSettings.show_businessname == 1
          "
          >-</em
        >
        {{ branch }}
      </h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">
                  Payments Report from {{ filterPayments.datefrom }} to
                  {{ filterPayments.dateto }}
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 py-3">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export
                </b-button>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>USERS</label>
                <model-list-select
                  :list="
                    Users ? [{ id: '', names: 'All Users' }, ...Users] : []
                  "
                  v-model="filterPayments.user"
                  option-value="id"
                  option-text="names"
                  placeholder="Select User"
                  @input="SalesPaymentsData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="filterPayments.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  v-model="filterPayments.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>CUSTOMERS</label>

                <model-list-select
                  :list="
                    Customers
                      ? [{ id: '', name: 'All Customers' }, ...Customers]
                      : []
                  "
                  v-model="filterPayments.customer"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Customer"
                  @input="SalesPaymentsData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="SalesPaymentsData()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                  v-if="!IsPaymentsDataServerPaginated"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <div>
                <DataTable
                  :columns="paymentsColumns"
                  :rows="PaymentsData"
                  :total-rows="rows"
                  :pagination="PaymentsDataPagination"
                  :server-pagination="IsPaymentsDataServerPaginated"
                  :loading="filterStatus"
                  row-class="payments-table-row"
                >
                  <template #cell(index)="{ index }">
                    {{ PaymentsDataPagination.from + index }}
                  </template>

                  <template #cell(amount)="{ value }">
                    {{ thousandSeperator(value) }}
                  </template>

                  <template #cell(actions)="{ row }">
                    <b-dropdown
                      text="More Actions..."
                      size="sm"
                      class="btn-primary"
                      v-if="MyUserPerm.modify_sales == 1"
                    >
                      <b-dropdown-item
                        v-if="MyUserPerm.delete_sales == 1"
                        v-b-modal.delete-payment-modal
                        @click="showDeleteModal(row)"
                      >
                        <i class="fa fa-trash text-danger"></i>
                        <span class="text-danger">Delete</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="MyUserPerm.edit_sales == 1"
                        v-b-modal.edit-payment-modal
                        @click="showEditModal(row)"
                        ><i class="fa fa-edit text-primary"></i>
                        <span class="text-primary">Edit</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>

                  <template #cell(branch)="{ value }">
                    {{ value }}
                  </template>
                </DataTable>
              </div>

              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
              </div>

              <!-- modal mark as expired starts -->
              <b-modal id="edit-payment-modal" hide-footer>
                <template #modal-title>
                  <h4 class="text-warning">
                    Edit Amount Paid For a Sale of
                    {{ thousandSeperator(editdata.amount) }}
                  </h4>
                </template>
                <label>Amount Paid</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.paid"
                    placeholder="Enter actual amount"
                    @input="resetError(), addCommas()"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('edit-payment-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-warning"
                    @click="editAmt('edit-payment-modal')"
                  >
                    <i class="fa fa-minus"></i> Confirm
                    <b-spinner
                      v-if="SaveSaleStatus"
                      variant="light"
                      small
                      label="Submiting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
              <!--Payment delete modal starts -->
              <b-modal
                header-bg-variant="danger"
                header-text-variant="light"
                body-text-variant="danger"
                footer-bg-variant="danger"
                footer-text-variant="danger"
                id="delete-payment-modal"
                hide-footer
                @hidden="resetDelete"
              >
                <template #modal-title>
                  Delete Payment of amount
                  {{ thousandSeperator(deletedata.amount) }}</template
                >
                <div class="form-group mb-2">
                  <div class="input-group">
                    <h5>
                      Do you want to delete this Payment? Click Proceed Button
                      to delete.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-payment-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="deletePayment('delete-payment-modal')"
                  >
                    <i class="fa fa-minus"></i> Proceed
                    <b-spinner
                      v-if="SaveSaleStatus"
                      variant="light"
                      small
                      label="Submiting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
